import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteQuestionOption } from "../../services/questionOptions";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteQuestionOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteQuestionOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Question option deleted successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useDeleteQuestionOption;